// // @ts-nocheck
// import React from 'react';

// const SalesPersonDeleteAlert = React.lazy(
//   () => import('@/containers/Alerts/SalesPeople/SalesPersonDeleteAlert'),
// );
// export default [{ name: 'salesperson-delete', component: SalesPersonDeleteAlert }];


// @ts-nocheck
import React from 'react';

const SalesPersonDeleteAlert = React.lazy(
  () => import('@/containers/Alerts/SalesPeople/SalesPersonDeleteAlert'),
);
export default [{ name: 'salesperson-delete', component: SalesPersonDeleteAlert }];
